const VisitorOverview = ({ data }) => {
  const items = [
    {
      label: "Total Visitor",
      value: data?.totalVisitorCount,
      icon: "T",
      bg: "bg-purple-light",
    },
    {
      label: "Last 7 Days",
      value: data?.weekCount,
      icon: "W",
      bg: "bg-blue-light",
    },
    {
      label: "This Month",
      value: data?.monthCount,
      icon: "M",
      bg: "bg-green-light",
    },
    {
      label: "This Year",
      value: data?.yearCount,
      icon: "Y",
      bg: "bg-orange-light",
    },
  ];

  return (
    <div className="col-lg-4">
      <div className="visitor-card h-100 mx-3">
        <h6 className="fw-bold mb-3">Visitor Overview</h6>

        <div className="d-flex flex-column gap-2">
          {items.map((item, index) => (
            <div className="visitor-item" key={index}>
              <div className="left">
                <div className={`icon-circle ${item.bg}`}>
                  {item.icon}
                </div>
                <span>{item.label}</span>
              </div>
              <span className="value">{item.value || 0}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VisitorOverview;